/* eslint-disable import/no-extraneous-dependencies */
import './DateRangeInput.scss';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { SingleInputDateRangeField } from '@mui/x-date-pickers-pro/SingleInputDateRangeField';
import dayjs from 'dayjs';

import Icon from 'atoms/icon';
import { addDays } from 'util';

export function DateRangeInput({ onChange, dateRanges }) {
  const [start, end] = dateRanges;

  return (
    <div className="date-range-input pos-relative">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateRangePicker
          slots={{ field: SingleInputDateRangeField }}
          name="allowedRange"
          defaultValue={[start, end]}
          onChange={onChange}
        />
      </LocalizationProvider>
      <Icon name="calendar" className="pos-absolute" fill="#9999b2" />
    </div>
  );
}
